import React, { useRef,useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";
import CustomButton from "../../../Components/Common/CustomButton";
import CustomInput from "../../../Components/Common/CustomInput";
import CommonLocationSelect from "../../../Components/Common/CommonLocationSelect";
import { fetchLocations, toggleEditForm, updateNestedItem } from "../../../redux/locations/locationSlice";
import { useSelector, useDispatch } from "react-redux";
import { clearServiceError, createService, getServices, updateService } from "../../../redux/service/serviceSlice";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Loader from "../../../Components/Common/Loader";
import Cookies from "js-cookie";

const AddServiceModal = ({ toggleModal,serviceId}) => {
  const [formData, setFormData] = useState({
    location: null,
    name: "",
    price: "",
    status: true,
  });
  const modalRef = useRef();
  const dispatch = useDispatch();
  const navigate=  useNavigate()
  const { editForm, selectedService,locations } = useSelector((state) => state.locations);
  const {isLoading,error,service,form} =  useSelector(state=>state.service)
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    dispatch(fetchLocations({ currentPage: null, itemsPerPage: null }));
  }, [dispatch,serviceId]);

  const filteredLocations = locations.filter((loc) => {
    const query = searchQuery.toLowerCase();
    return (
      loc.name?.toLowerCase().includes(query) ||
      loc.address?.city?.toLowerCase().includes(query) ||
      loc.address?.state?.toLowerCase().includes(query)
    );
  });
 
  const handleLocationSelect = (location) => {
    setFormData((prev) => ({
      ...prev,
      location,
    }));
    setSearchQuery("");
  };

  const handleServiceChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

 
  const apiCallResultSuccess = () => {
    setFormData({
      location: null,
      name: "",
      price: "",
      status: true,
      serviceId: null,
    });
    toggleModal()
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // ✅ Validate Location
    if (!formData.location || !formData.location._id) {
      toast.error("Please select a valid location.");
      return;
    }
  
    // ✅ Validate Service Name
    if (!formData.name.trim()) {
      toast.error("Service name is required.");
      return;
    }
  
    // ✅ Validate Price (must be a positive number)
    const price =  formData.price
    if (price <= 0) {
      toast.error("Price must be a valid number greater than 0.");
      return;
    }
  
    const serviceData = {
      locationId: formData.location._id,
      name: formData.name,  
      price,
    };
  
    try {
      const response =  serviceId
        ? await dispatch(
            updateService({
                 id:serviceId,
              data: serviceData,
            })
          ).unwrap()
        : await dispatch(createService({...serviceData,status: formData.status,tenantId:Cookies.get("TenantId")})).unwrap();
      if (!serviceId) dispatch(getServices({ locationId: null, page: 1, sortBy: "name", order: "desc", limit: 5 }));
  
      apiCallResultSuccess();
      toast.success(
        formData.serviceId
          ? "Service updated successfully!"
          : "Service added successfully!"
      );
    } catch (error) {
  toast.dismiss();
  
  const message = error?.response?.data?.error?.message || error?.message || error;
  toast.error(message);
}
  };

  useEffect(() => {
    if (serviceId && service) {
      const location =  locations.find((loc) => loc._id === service.locationId);
      setFormData({
        location: location,
        name: service.name,
        price: service.price,
        status: service.status,
      });
    }
  }, [serviceId, service]);

  const handleClickOutside = (event) => {
    event.stopPropagation(); 
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      toggleModal()
    }
  };

  const handleClose = () => {
    navigate("/general/services");
    toggleModal()
  }

  const handleLocationClear = () => {
    setFormData({
      ...formData,
      location: "",
      name: "",
      price: "",
    });
  };


if(!form){
  return null
}
  return (
    <div className="fixed z-10 inset-0 overflow-y-auto" onClick={handleClickOutside}>
    <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
      <div className="fixed inset-0 transition-opacity" aria-hidden="true">
        <div className="absolute inset-0 bg-gray-500 bg-opacity-40 backdrop-blur-sm"></div>
      </div>
      <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      
      <div 
        ref={modalRef} 
        className="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg w-full"
      >
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-4 flex items-center justify-between border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-800">
            {serviceId ? "Update Service" : "Add New Service"}
          </h2>
          <button
            onClick={handleClose}
            className="text-gray-500 hover:text-gray-700 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 rounded-full p-1"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <div className="bg-white px-6 py-5">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="mb-2">
              <CommonLocationSelect
                locations={filteredLocations}
                value={formData.location}
                onChange={handleLocationSelect}
                onClear={handleLocationClear}
              />
            </div>
            
            <div className="grid grid-cols-1 gap-5">
              <CustomInput
                type="text"
                id="name"
                label="Service Name"
                value={formData.name}
                placeholder="Enter service name"
                onchange={(e) => handleServiceChange('name', e.target.value)}
                required={true}
              />
              
              <CustomInput
                type="text"
                id="price"
                label="Price"
                placeholder="Enter price"
                value={formData.price}
                onchange={(e) => handleServiceChange('price', e.target.value)}
                required={true}
              />
            </div>
            
            <div className="mt-6 flex justify-end space-x-3 pt-4 border-t border-gray-100">
              <CustomButton 
                text="Cancel" 
                onClick={handleClose} 
              />
              <CustomButton 
                type="submit" 
                text={isLoading ? "Saving..." : "Save Service"} 
                loading={isLoading}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  );
};

export default AddServiceModal;